<template>
  <div class="top-nav" v-if="$route.name != 'Detail Pesan'">
    <svg
      class="humburger-menu"
      width="30"
      height="26"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 2H22"
        stroke="#5BC77A"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M2 10H15"
        stroke="#5BC77A"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M2 18H22"
        stroke="#5BC77A"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>

    <h3 class="nama-halaman">
      {{ $route.meta.title ? $route.meta.title : "Kostoo" }}
    </h3>

    <svg
      @click="
        () => {
          handleNav('/pesan');
        }
      "
      width="34"
      height="33"
      viewBox="0 0 29 27"
      fill="#5BC77A"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.49549 10.8896C3.82438 11.1067 4.8158 11.7514 6.46979 12.8234C8.12382 13.8954 9.39093 14.7209 10.2712 15.2997C10.3679 15.3632 10.5733 15.5011 10.8876 15.7137C11.202 15.9265 11.4632 16.0984 11.671 16.2296C11.879 16.3607 12.1305 16.5077 12.4256 16.6705C12.7207 16.8332 12.9988 16.9555 13.26 17.0365C13.5212 17.1182 13.763 17.1586 13.9854 17.1586H14H14.0146C14.2371 17.1586 14.479 17.1181 14.7402 17.0365C15.0012 16.9555 15.2796 16.833 15.5744 16.6705C15.8694 16.5075 16.1208 16.3606 16.3288 16.2296C16.5368 16.0984 16.7978 15.9265 17.1123 15.7137C17.4265 15.5009 17.6322 15.3632 17.729 15.2997C18.6187 14.7209 20.8823 13.2507 24.5191 10.8893C25.2251 10.4281 25.815 9.8716 26.2889 9.22018C26.7631 8.56905 27 7.88597 27 7.17134C27 6.57415 26.7702 6.06295 26.3107 5.63778C25.8512 5.21251 25.307 5 24.6785 5H3.32133C2.57659 5 2.00346 5.23519 1.60205 5.70556C1.20068 6.17603 1 6.76409 1 7.46969C1 8.03964 1.26609 8.65727 1.798 9.32219C2.32987 9.98715 2.89588 10.5097 3.49549 10.8896Z"
      />
      <path
        d="M25.5489 12.3415C22.3766 14.3497 19.9679 15.9105 18.3237 17.0234C17.7724 17.4032 17.3251 17.6997 16.9817 17.9122C16.6382 18.1248 16.1814 18.3419 15.6106 18.5634C15.04 18.7853 14.5082 18.8959 14.0148 18.8959H14.0001H13.9855C13.4922 18.8959 12.9601 18.7853 12.3895 18.5634C11.8189 18.3419 11.3618 18.1248 11.0184 17.9122C10.6752 17.6997 10.2278 17.4032 9.67648 17.0234C8.3706 16.1278 5.96699 14.5669 2.46555 12.3415C1.91407 11.9979 1.4256 11.6041 1 11.1609V21.9356C1 22.533 1.22721 23.044 1.68188 23.4692C2.13645 23.8945 2.68305 24.1071 3.32149 24.1071H24.6787C25.317 24.1071 25.8636 23.8945 26.3182 23.4692C26.7729 23.0438 27.0001 22.5331 27.0001 21.9356V11.1609C26.5841 11.5949 26.1006 11.9887 25.5489 12.3415Z"
        fill="#5BC77A"
      />
    </svg>
  </div>
</template>

<script>
import firebase from "../firebase";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    handleNav(toRoute) {
      if (this.userProfile.role == "desa" && toRoute == "/investor") {
        toRoute = "/desa";
      }
      if (this.$route.fullPath != toRoute) {
        this.$router.push(toRoute);
      }
    }
  },
  computed: {
     ...mapState(["userProfile", "currentUser"])
  }
};
</script>

<style scoped>
@import url("../assets/css/navbar.css");
</style>
